<template lang="pug">
//- 精緻團班
.course-in-index.page-index
  //- 內容 TOP (內有 搜尋bar 及 通知區塊 )
  ContentTop
  .row.course-in-content
    .course-in-content-left.padding-right-none
      .course-in-main
        .course-in-title
          .title {{ series.title }}
          .text {{ series.course_freshman.length }}則・{{ series.teacher.name }}
        .course-bgimg
          img(
            v-if="series.langs_type === 'en'",
            src="@/assets/images/e-01@3x.png"
          )
          img(
            v-if="series.langs_type === 'ja'",
            src="@/assets/images/j-01@3x.png"
          )
          img(
            v-if="series.langs_type === 'ko'",
            src="@/assets/images/k-01@3x.png"
          )
    .course-in-content-right.padding-none
      .new-park-topic-title {{ series.title }}
      .topic-article-list-title 文章列表
      .topic-article-list
        .topic-article-item(
          v-for="(course, index) in series.course_freshman",
          @click="getCourseLiveVideoUri(index)"
        )
          .topic-article-item-title {{ course.course_name_zh }}
          .topic-article-item-sm-title {{ course.course_name_en }}
          img.topic-btn(src="@/assets/images/menu-live-b.png")
</template>
<script>
// import $ from 'jquery'
import ContentTop from '@/components/content-top/content-top'
export default {
  coures_teacher: {
    name: 'CourseIn',
  },
  components: {
    ContentTop,
  },
  data () {
    return {
      new_study_id: false,
      course: {},
      series: {}
    };
  },
  async created () {
    // 獲取ID
    this.new_study_id = this.$route.params.new_study_id
    // 獲取資料
    this.series = this.$root.new_park_view_details
    // 設置課程資料
    this.course = {}
  },
  mounted () {
    this.$root.closeLoading()
  },
  watch: {

  },
  computed: {
  },
  methods: {
    // 獲取新生學園指定課程的影片 URI
    getCourseLiveVideoUri (_courseIndex) {
      // 進行身份驗證
      if (!this.$root.user.is_freshman) {
        return this.$root.openOptionView({
          title: "身份驗證失敗",
          text_1: "您的帳號未開通『新生學園』課程",
          text_2: "請洽客服人員進行開通",
          option_1: "瞭解",
        })
      }

      this.course = {
        course_id: this.series.course_freshman[_courseIndex].course_video_id,
        course_name: this.series.course_freshman[_courseIndex].course_name_zh,
        course_lang: this.series.langs_type,
        course_live_uri: ""
      }
      this.$root.apis.getVideoUri(this.series.course_freshman[_courseIndex].course_video_id, this.openLiveScreen, this.processStatusError)
    },
    openLiveScreen (_response) {
      if (_response.body.error_code !== 0) {
        return this.processStatusError(_response)
      }
      this.course.course_live_uri = this.$root.site_path + _response.body.data
      this.$root.new_park_view_course = this.course
      this.$root.live_open_persent = true
      // this.$root.live_view_status = true
      // this.$root.live_view_anim = true
      console.log("--> 帶入的課程資料, 啟動直播頁面... ", this.course)
      this.$root.common.goLive(this.new_study_id, 'park')
    },
    processStatusError () { }
  }
}
</script>
<style lang="sass">
.new-park-topic-title
  margin-top: 4.8rem
  font-size: 20px
  font-weight: 500
  color: #191d35
  text-align: left
.topic-article-list-title
  font-size: 15px
  font-weight: 600
  color: #35383b
  text-align: left
  margin-top: 1.2rem
.topic-article-list
  margin-top: 1rem
  height: 34rem
  padding: 0 .5rem
  overflow: auto
  .topic-article-item
    width: calc(100% - 40px)
    padding: 20px 20px 22px 20px
    border-radius: 17.5px
    box-shadow: 0 2px 10px 5px rgba(37, 39, 38, 0.05)
    background-color: #fbfbfb
    margin-bottom: 10px
    position: relative
    &:active
      opacity: .8
    .topic-article-item-title
      font-size: 15px
      font-weight: 500
      color: #191d35
      text-align: left
    .topic-article-item-sm-title
      font-size: 15px
      font-weight: 500
      color: #5d5d5e
      text-align: left
      margin-top: .1rem
    .topic-btn
      position: absolute
      width: 2rem
      right: 1.5rem
      top: 1.7rem
</style>
